import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { DEMO_LIBRARY } from '../../data/demo';
import { useDemo } from '../../contexts/DemoContext';
import { LENTIC_LOCKUP } from '../../utils/documentMeta';
export { LENTIC_LOCKUP };
export function LenticMark({
  dark = false
}: {
  dark?: boolean;
}) {
  return <Link to="/demo" className="inline-flex items-center" aria-label="Lentic" data-id="element-45" data-mp="38ng7wutmtf18">
      <img src={LENTIC_LOCKUP} alt="Lentic"
    // On the navy machine-room surface the navy wordmark needs to invert to white.
    className={`h-10 w-auto ${dark ? 'brightness-0 invert' : ''}`} data-id="element-46" data-mp="2azo8rvb0k3r0" />
    </Link>;
}
export function BackLink({
  to,
  label,
  dark = false
}: {
  to: string;
  label: string;
  dark?: boolean;
}) {
  const navigate = useNavigate();
  return <button type="button" onClick={() => navigate(to)} className={`inline-flex items-center gap-1.5 font-mono-num text-[11px] uppercase tracking-[0.12em] transition-colors ${dark ? 'text-white/50 hover:text-white' : 'text-muted hover:text-ink'}`} data-id="element-47" data-mp="5abe8d3s39r">
      <ArrowLeftIcon className="h-3 w-3" data-id="element-48" data-mp="3hjmw2dwftx31" />
      {label}
    </button>;
}
export function DemoFooter({
  dark = false
}: {
  dark?: boolean;
}) {
  const {
    bundle
  } = useDemo();
  const label = bundle.label;
  return <footer className={`border-t ${dark ? 'border-white/10' : 'border-rule'}`} data-id="element-49" data-mp="38h55xodnwkar">
      <div className={`mx-auto flex max-w-[1400px] flex-wrap items-center gap-x-3 gap-y-1 px-8 py-4 font-mono-num text-[11px] ${dark ? 'text-white/35' : 'text-muted/70'}`} data-id="element-50" data-mp="33jlrand1y5ia">
        <span data-id="element-51" data-mp="2ttk37vkp8n3d">Lentic demo</span>
        <span aria-hidden="true" data-id="element-52" data-mp="2tqefajnt3r98">·</span>
        <span data-id="element-53" data-mp="2prymu08yhqof">{label}</span>
        <span aria-hidden="true" data-id="element-54" data-mp="2psqhn8uqbkdn">·</span>
        <span data-id="element-55" data-mp="2ks2r0oaex5jy">library {DEMO_LIBRARY}</span>
      </div>
    </footer>;
}